import { Injectable } from "@angular/core";
import { Configuration } from "./configuration";


@Injectable({
  providedIn: "root",
})
export class ConfigurationService {
  private configuration: Configuration;

  get(): Configuration {
    return this.configuration;
  }

  get getEnv(): string {
    return this.configuration.environmentURL
  }

  getBaseURL(): string {
    return this.configuration.apiEndpoint;
  }
  getURL(): string {
    return this.configuration.url
  }
  getSubscriptionURL(): string {
    return this.configuration.subscriptionURL
  }
  getCustumAPIEndPoint(): string {
    return this.configuration.customAPIEndPoint;
  }

  async loadConfiguration(): Promise<void> {
     
    const response = await fetch("/api/configuration");
    const configuration = await response.json();
    this.configuration = configuration;
    console.log(configuration)
  }
  andicaCentralURL(): any {
    return this.configuration.andicaCentralURL;
  }
}
